import React from 'react';
import connect from 'app/api/redux-util/connect-enhancer';
import { setLastBrandAccessed } from '../../../api/redux-jigsaw/jigsaw-action';
import RedirectOnce from '../../route/RedirectOnce';
import { DEFAULT } from '../../../api/redux-route/routes';

class LoginRedirect extends React.Component {
  componentDidMount() {
    this.props.setLastBrand();
  }

  render() {
    return <RedirectOnce to={DEFAULT} />;
  }
}

const mapDispatchToProps = dispatch => ({
  setLastBrand: () => dispatch(setLastBrandAccessed()),
});

export default connect(null, mapDispatchToProps)(LoginRedirect);

export const LoginRedirectTest = LoginRedirect;
